import * as React from 'react';
import { SocialBarIcon } from './SocialBarIcon';
import { st, classes } from './SocialBar.st.css';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { SocialBarThemes } from './consts';
import { SocialBarProvider } from './SocialBarContext';
export const SocialBar = ({ theme = SocialBarThemes.light, children, className, 'data-hook': dataHook, }) => {
    const { mobile } = useTPAComponentsContext();
    return (React.createElement(SocialBarProvider, { value: theme },
        React.createElement("ul", { className: st(classes.root, { mobile }, className), "data-hook": dataHook }, children)));
};
SocialBar.Icon = SocialBarIcon;
//# sourceMappingURL=SocialBar.js.map